import React from 'react';

export default function CircleMedium({ size, color }) {
  return (
    <svg width={size} height={size} fill={color} viewBox="0 0 24 24"><title>circle-medium</title><path d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z" /></svg>
  );
}
